export enum BeltColorEnum {
  YELLOW = 'jaune',
  ORANGE = 'orange',
  GREEN = 'verte',
  BLUE = 'bleue',
  BROWN = 'marron',
  BLACK = 'noire'
}
